const PaymentMethods = {
  AFTERPAY: 'afterpay',
  ALIA_CARD: 'alia_card',
  ALIPAY: 'alipay',
  AMAZONPAY: 'amazonpay',
  AMEX: 'amex',
  APPLEPAY: 'apple_pay',
  ARGENCARD: 'argencard',
  AURA: 'aura',
  BACS: 'bacs',
  BALOTO: 'baloto',
  BANCARD: 'bancard',
  BANCNET: 'bancnet',
  BANCO_DE_CREDITO: 'banco_de_credito',
  BANCO_DO_BRASIL: 'banco_do_brasil',
  BANCO_NACION: 'banco_nacion',
  BANCO_PROVINCIA: 'banco_provincia',
  BANCOMAT: 'bancomat',
  BANCONTACT: 'bancontact',
  BANK_TRANSFER: 'bank_transfer',
  BANKAXEPT: 'bankaxept',
  BANORTE: 'banorte',
  BBVA_BANCOMER: 'bbva_bancomer',
  BELFIUS: 'belfius',
  BITCOIN: 'bitcoin',
  BOLETO: 'boleto',
  BLIK: 'blik',
  BRADESCO: 'bradesco',
  CABAL: 'cabal',
  CAIXA: 'caixa',
  CARDOBESA: 'cardobesa',
  CASH: 'cash',
  CASHTOCODE: 'cashtocode',
  CB: 'cb',
  CENCOSUD: 'cencosud',
  CIRRUS: 'cirrus',
  CITI: 'citi',
  CITRUS_PAY: 'citrus_pay',
  CMR_FALABELLA: 'cmr_falabella',
  CORDIAL: 'cordial',
  CREDIT_COOP: 'credit_coop',
  CUP: 'cup',
  DANKORT: 'dankort',
  DAVIVIENDA: 'davivienda',
  DINERS: 'diners',
  DISCOVER: 'discover',
  DOKU_WALLET: 'doku_wallet',
  EFECTY: 'efecty',
  ELO: 'elo',
  EPS: 'eps',
  EPS_HK: 'eps_hk',
  ETHEREUM: 'ethereum',
  GALICIA: 'galicia',
  GARANTIPAY: 'garantipay',
  GCASH: 'gcash',
  GIROCARD: 'girocard',
  GIROPAY: 'giropay',
  GOOGLEPAY: 'google_pay',
  HIPERCARD: 'hipercard',
  HSBC: 'hsbc',
  IDEAL: 'ideal',
  INTERAC: 'interac',
  INTERAC_CARD: 'interac_card',
  INTERBAN: 'interban',
  ITAU: 'itau',
  J_DEBIT: 'j_debit',
  JCB: 'jcb',
  KBC: 'kbc',
  KLARNA: 'klarna',
  KNET: 'knet',
  KONBINI: 'konbini',
  LIDER: 'lider',
  LOCAL_CARDS: 'local_cards',
  MACRO: 'macro',
  MADA: 'mada',
  MAESTRO: 'maestro',
  MAGNA: 'magna',
  MASTERCARD: 'mastercard',
  MASTERPASS: 'masterpass',
  MBWAY: 'mbway',
  MERCADO_LIVRE: 'mercado_livre',
  MERCADO_PAGO: 'mercado_pago',
  MIR: 'mir',
  MOBIKWIK: 'mobikwik',
  MOBILE_WALLETS: 'mobile_wallets',
  MOBILEPAY: 'mobilepay',
  MULTIBANCO: 'multibanco',
  MY_DEBIT: 'my_debit',
  MYBANK: 'mybank',
  NARANJA: 'naranja',
  NATIVA: 'nativa',
  NETS: 'nets',
  NORBRPAY: 'norbrpay',
  NPAY: 'npay',
  OCA_CARD: 'oca_card',
  OXXO: 'oxxo',
  P24: 'p24',
  PAGO_EFECTIVO: 'pago_efectivo',
  PAGO_EXPRESS: 'pago_express',
  PAGO_FACIL: 'pago_facil',
  PAYCONIQ: 'payconiq',
  PAY_BY_LINKS: 'pay_by_links',
  PAY_WITH_IYZICO: 'pay_with_iyzico',
  PAYMAYA_WALLET: 'paymaya_wallet',
  PAYPAL: 'paypal',
  PAYSAFECARD: 'paysafecard',
  PAYU_WALLET: 'payu_wallet',
  PIC_PAY: 'pic_pay',
  PIX: 'pix',
  POLI: 'poli',
  PRESTO: 'presto',
  PSE: 'pse',
  QIWI: 'qiwi',
  QPAY: 'qpay',
  RAPI_PAGO: 'rapi_pago',
  RATEPAY: 'ratepay',
  RED_COMPRA: 'red_compra',
  RED_PAGOS: 'red_pagos',
  RUPAY: 'rupay',
  SANTANDER: 'santander',
  SATISPAY: 'satispay',
  SCOTIA_BANK: 'scotia_bank',
  SDD: 'sdd',
  SERVI_PAGO: 'servi_pago',
  SISAL: 'sisal',
  SOFORT: 'sofort',
  SPEI: 'spei',
  SUPERCASH: 'supercash',
  SWISH: 'swish',
  TARJETA_SHOPPING: 'tarjeta_shopping',
  TROY: 'troy',
  TRUE_MONEY: 'true_money',
  TRUSTLY: 'trustly',
  UPI: 'upi',
  VIPPS: 'vipps',
  VISA: 'visa',
  VOLT: 'volt',
  WE_CHAT: 'we_chat',
  WEB_PAY: 'web_pay',
  WESTERN_UNION: 'western_union',
  YANDEX: 'yandex',
  ZIP: 'zip',
};

module.exports = PaymentMethods;
